var drawer = document.getElementById('drawer-nav');
var overlay = document.getElementById('drawer-overlay');
var openBtn = document.getElementById('hamburger-btn');
var closeBtn = document.getElementById('drawer-close-btn');

function openDrawer() {
  drawer.classList.add('is-open');
  overlay.classList.add('is-visible');
  document.body.style.overflow = 'hidden';
}
function closeDrawer() {
  drawer.classList.remove('is-open');
  overlay.classList.remove('is-visible');
  document.body.style.overflow = '';
}

if (openBtn) openBtn.addEventListener('click', openDrawer);
if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
if (overlay) overlay.addEventListener('click', closeDrawer);

document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') closeDrawer();
});

// Accordion submenus
document.querySelectorAll('.drawer-toggle').forEach(function(btn) {
  btn.addEventListener('click', function() {
    var open = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', !open);
    btn.nextElementSibling.classList.toggle('is-open', !open);
    btn.querySelector('.drawer-arrow').style.transform = open ? '' : 'rotate(90deg)';
  });
});
